__turbopack_context__.v({
  "buttons-container": "account-module-scss-module__OIX8nq__buttons-container",
  "content": "account-module-scss-module__OIX8nq__content",
  "content-container": "account-module-scss-module__OIX8nq__content-container",
  "fade-in-ux308cn": "account-module-scss-module__OIX8nq__fade-in-ux308cn",
  "fade-in-ux308cv": "account-module-scss-module__OIX8nq__fade-in-ux308cv",
  "fade-in-ux308dt": "account-module-scss-module__OIX8nq__fade-in-ux308dt",
  "main": "account-module-scss-module__OIX8nq__main",
  "section-content": "account-module-scss-module__OIX8nq__section-content",
  "section-title": "account-module-scss-module__OIX8nq__section-title",
  "title": "account-module-scss-module__OIX8nq__title",
  "title-container": "account-module-scss-module__OIX8nq__title-container",
});
